import { render, staticRenderFns } from "./ProcessWidget.vue?vue&type=template&id=4a64a9fb&"
import script from "./ProcessWidget.vue?vue&type=script&lang=js&"
export * from "./ProcessWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProcessWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports